import find from 'lodash/find';

import {push} from '../router/router-actions';

export const SPOT_UPDATE_SELECTED = 'SPOT_UPDATE_SELECTED';
export const SPOT_CHANGE_MULTI_RATE = 'SPOT_CHANGE_MULTI_RATE';
export const SPOT_RESET_SELECTED_SPOT = 'SPOT_RESET_SELECTED_SPOT';
export const SPOT_RESET_SELECTED_RATE = 'SPOT_RESET_SELECTED_RATE';
export const SPOT_DETAIL_REFERRER = 'SPOT_DETAIL_REFERRER';

export const updateSelected = ({spot, referrer, goToSpotUrl = false} = {}) => {
    return dispatch => {
        dispatch({
            type: SPOT_UPDATE_SELECTED,
            payload: {
                spot,
                referrer,
                goToSpotUrl,
            },
        });

        if (goToSpotUrl && spot) {
            dispatch(push(spot.selectedRate.fullUrl));
        }
    };
};

// Used on search controls only
export const resetSelectedSpot = () => {
    return {
        type: SPOT_RESET_SELECTED_SPOT,
    };
};

// Used on Checkout only
// newRateRule is number or string
export const changeMultiRate = ({newRateRule, rates}) => {
    const ruleNumber = parseInt(newRateRule, 10);
    const ruleRate = Number.isNaN(ruleNumber) ? newRateRule : ruleNumber;

    return {
        type: SPOT_CHANGE_MULTI_RATE,
        payload: {
            newRate: find(rates, {fullRule: ruleRate}) || null,
            rid: ruleRate,
        },
    };
};

// Used on Checkout only
export const resetSelectedRate = () => {
    return {
        type: SPOT_RESET_SELECTED_RATE,
    };
};

export const setSpotDetailReferrer = referrer => {
    return {
        type: SPOT_DETAIL_REFERRER,
        payload: {referrer},
    };
};
